import React from 'react';
import {BasicVacancyCard} from "./BasicVacancyCard";
import { ReplyButton } from '../ReplyButton';
import { Vacancy } from '../../types';

export function VacancyCardStudent({ vacancy } : { vacancy: Vacancy }) {
  return (
    <BasicVacancyCard
      vacancy={vacancy}
    >
      <ReplyButton style={{marginTop: "12px", height: '32px'}} vacancyId={vacancy.id} reaction={vacancy.isReaction}></ReplyButton>
    </BasicVacancyCard>
  )
}